"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faCircle_1 = require("@fortawesome/pro-light-svg-icons/faCircle");
var faFileSlash_1 = require("@fortawesome/pro-regular-svg-icons/faFileSlash");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var Box_1 = __importDefault(require("@mui/material/Box"));
var SIZE_MAPPER = {
    sm: 14, md: 18, lg: 24, xl: 64,
};
var ExcludeCharge = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'md' : _b;
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ sx: { color: 'red.contrastText' }, display: "inline-block", height: SIZE_MAPPER[size], width: SIZE_MAPPER[size], position: "relative" }, { children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faCircle_1.faCircle, style: { fontSize: SIZE_MAPPER[size] } }), (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ component: "span", position: "absolute", top: 16, left: 12 }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faFileSlash_1.faFileSlash, style: { fontSize: SIZE_MAPPER[size] / 2 } }) }))] })));
};
exports.default = ExcludeCharge;
